export default __webpack_public_path__ + "static/school-primary-years-a06797ec79f49113e6eb2c3b7e6c8b92.jpg";